import { QuoteOptionParams } from "@models/Quote";
import { getRoute } from "@utils/route";

export const HEALTH_QUOTE_ROUTE_URL = '/health-insurance-quote/*';
export const HEALTH_QUOTE_PAGE_URL = '/health-insurance-quote';

export const routeHealthQuotePage = (options?: QuoteOptionParams & { path: 'members' }) => {
  if (!options) return getRoute(HEALTH_QUOTE_PAGE_URL);
  const { path, ...searchParams } = options;
  return getRoute(`${HEALTH_QUOTE_PAGE_URL}/${path}`, { searchParams });
}
export const CANCER_QUOTE_ROUTE_URL = '/cancer-insurance-quote/*';
export const CANCER_QUOTE_PAGE_URL = '/cancer-insurance-quote';

export const routeCancerQuotePage = (options?: QuoteOptionParams & { path: 'members' }) => {
  if (!options) return getRoute(CANCER_QUOTE_PAGE_URL);
  const { path, ...searchParams } = options;
  return getRoute(`${CANCER_QUOTE_PAGE_URL}/${path}`, { searchParams });
}

export const PERSONAL_ACCIDENT_QUOTE_ROUTE_URL = '/personal-accident-insurance-quote/*';
export const PERSONAL_ACCIDENT_QUOTE_PAGE_URL = '/personal-accident-insurance-quote';

export const routePersonalAccidentQuotePage = (options?: QuoteOptionParams & { path: 'members' }) => {
  if (!options) return getRoute(PERSONAL_ACCIDENT_QUOTE_PAGE_URL);
  const { path, ...searchParams } = options;
  return getRoute(`${PERSONAL_ACCIDENT_QUOTE_PAGE_URL}/${path}`, { searchParams });
}
